module.exports = __webpack_public_path__ + "static/media/v_logo_vip-lrp.eed70931.png";